import { EarningMechanismFragment } from '@occc/graphql';
import { AwardFragment } from '@occc-app/offerHelpers/types';

import { earningMechanismHelper } from './earningMechanismHelper';

// TODO: think - do we need to handle null award?
export const getEarningMechanismAward = (
  earningMechanism: EarningMechanismFragment,
): AwardFragment | null | undefined => {
  if (earningMechanismHelper.isTotalEligiblePurchase(earningMechanism)) {
    return earningMechanism.totalEligiblePurchaseAward;
  }
  if (earningMechanismHelper.isExternalFulfillment(earningMechanism)) {
    return earningMechanism.externalFulfillmentAward;
  }
  if (earningMechanismHelper.isTotalEligiblePurchaseOverTime(earningMechanism)) {
    return earningMechanism.totalEligiblePurchaseOverTimeAward;
  }
  if (earningMechanismHelper.isProductPurchase(earningMechanism)) {
    return earningMechanism.productPurchaseAward;
  }
  if (earningMechanismHelper.isTotalSpendOverTime(earningMechanism)) {
    return earningMechanism.totalSpendOverTimeAward;
  }
  if (earningMechanismHelper.isTotalSpendOnTransaction(earningMechanism)) {
    return earningMechanism.totalSpendOnTransactionAward;
  }
  if (earningMechanismHelper.isVisits(earningMechanism)) {
    return earningMechanism.visitsAward;
  }
  if (earningMechanismHelper.isLoyaltyEvent(earningMechanism)) {
    return earningMechanism.loyaltyEventAward;
  }
  if (earningMechanismHelper.isMembershipEvent(earningMechanism)) {
    return earningMechanism.membershipEventAward;
  }
  if (earningMechanismHelper.isVarietyPurchase(earningMechanism)) {
    return earningMechanism.varietyPurchaseAward;
  }
  if (earningMechanismHelper.isVarietyPurchaseOverTime(earningMechanism)) {
    return earningMechanism.varietyPurchaseOverTimeAward;
  }
  if (earningMechanismHelper.isPointSpend(earningMechanism)) {
    return earningMechanism.pointSpendAward;
  }
  if (earningMechanismHelper.isTransactionDiscount(earningMechanism)) {
    return earningMechanism.transactionDiscountAward;
  }
  if (earningMechanismHelper.isProductDiscount(earningMechanism)) {
    return earningMechanism.productDiscountAward;
  }
  if (earningMechanismHelper.isVarietyDiscount(earningMechanism)) {
    return earningMechanism.varietyDiscountAward;
  }
  return null;
};
